<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.email">
      <v-form ref="form" v-model="validForm" autocomplete="off" role="presentation">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-select
                :readonly="readonly"
                clearable
                md4
                v-model="item.role"
                :items="roles"
                label="Role"
                :rules="validators.account.role"
                @change="updateRole"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-select
                :readonly="readonly"
                clearable
                md4
                v-model="item.status"
                :items="statuses"
                label="Status"
                :rules="validators.account.status"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                label="First Name"
                v-model="item.name"
                :rules="validators.account.name"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Last Name"
                v-model="item.surname"
                :rules="item.role != 'Provider' ? validators.account.surname : []"
                v-if="item.role != 'Provider' && item.role != 'EMN Client'"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                label="Email"
                :disabled="!(isNew)"
                v-model="item.email"
                :rules="validators.username"
                autocomplete="none"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                label="Username"
                :disabled="!(isNew || $store.getters.role=='Administrator') "
                v-model="item.username"
                :rules="validators.username"
                autocomplete="none"
              ></v-text-field>
            </v-flex>

            <!-- TODO commentata password perchè alla creazione l'utente riceve una email dove impostarla -->
            <!-- <v-flex xs12 sm6 md6>
              <v-text-field
                :readonly="readonly"
                type="password"
                label="Password"
                v-if="isNew"
                v-model="item.password"
                :rules="validators.account.password"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex> -->

            <v-flex xs12 sm12 md12>
               <v-autocomplete
                :disabled="item.role == 'Administrator'"
                multiple
                v-model="item.sponsors"
                :items="sponsors"
                item-value="id"
                item-text="name"
                label="Sponsors"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12 md12>
               <v-autocomplete
                v-if="item.role == 'Medical Monitor' || item.role == 'CRO Pharmacovigilance' || item.role == 'Provider'"
                multiple
                v-model="item.protocols"
                :items="protocols"
                item-value="id"
                item-text="name"
                label="Protocols"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                :rules="[v => !!v.length || 'Protocol required']"
                @keydown.space.prevent>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm3 md3 v-if="item.role == 'Employee' || item.role == 'Administrator'">
              <v-checkbox 
                label="Quality Check" 
                v-model="item.quality_check"
                v-bind:false-value="0"
                v-bind:true-value="1"
                :readonly="!$can('upsert', 'adverse_event')"
                ></v-checkbox>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          v-if="$can('upsert', 'account')"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail, getRoles, getStatuses } from "@/api/account";
import { getList as getProtocols } from "@/api/protocol";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    item : {},
    value: false
  },
  data() {
    return {
      validForm: true,
      validators,
      roles : getRoles(),
      statuses: getStatuses(),
      protocols: []
    };
  },
  mounted() {
  },
  watch: {
    value() {
      let protocolFilter={"protocol.status": ['Open','Draft']}
      if(this.$store.getters.isShowClosedProtocol){
        protocolFilter={"protocol.status": ['Open','Draft','Closed']}
      }
      getProtocols({protocolFilter},{rowsPerPage:-1, sortBy:'name'}).then( data => {
        this.protocols = data.data
      })
      if (this.isNew) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Account" : (this.readonly ? 'Account details' : "Edit Account" );
    },
    readonly() {
      return !(this.$can('upsert', 'account') || this.$store.getters.role==='Administrator');
    },
    sponsors() {
        return this.$store.getters.sponsors;
    },
    // protocols() {
    //     return this.$store.getters.protocols;
    // },
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
      });
    },
    close() {
       this.$emit('input', false)
    },
    updateRole() {
      if(this.item.role == 'Administrator') {
        this.item.sponsors = null;
      }
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          const message = this.isNew ? "Account created correctly" : 
            "Account updated correctly";
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "success"
          });
          // const newItem = JSON.parse(JSON.stringify(data.data));
          this.$root.$emit('updateAccounts');
        })
        .catch(e => {
          const mex = this.isNew ? "An Error occurred during the Account create. " : 
            "An Error occurred during the Account update. ";
          this.$store.dispatch("app/openSnackbar", {
            message: mex + e.response.data.message,
            color: "error"
          });
        }).finally( () => {
          this.close()
        })
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
